export enum VerificationType {
  patientMatch = 'patient_match',
  prescriberMatch = 'prescriber_match',
  referralMatch = 'referral_match',
  drugMatch = 'drug_match',
  specialistEncounterDate = 'specialist_encounter_date',
}
